import React, { useEffect, useRef } from 'react';
import { Controller } from 'react-hook-form';
import FlexSelect from 'components/Inputs/FlexSelect';
import useMonitoringQueueGroups from 'hooks/useMonitoringQueueGroups';
import { Col } from 'reactstrap';

const GroupingsMacroFilter = ({ 
  control, 
  setValue, 
  watch, 
  queueField = 'queue', 
  agentField = 'agent', 
  agentsList = [], 
  queuesList = [],
  agentValueField = 'login',
  queueValueField = 'id',
  agentCompareField = 'login',
  queueCompareField = 'id',
  colSize = 6
}) => {
  const { response: groupings, isLoading } = useMonitoringQueueGroups({ itemsPerPage: 1000 });
  const selectedGroupingsIds = watch('agrupamentos_macro_id');
  const prevSelectedRef = useRef(null);

  useEffect(() => {
    // Só age quando o usuário realmente altera a seleção
    // para evitar apagar a `fila` e o `agente` memorizados na montagem.
    if (selectedGroupingsIds !== prevSelectedRef.current) {
        
      if (selectedGroupingsIds && selectedGroupingsIds.length > 0) {
        const selectedGroups = groupings.filter(g => selectedGroupingsIds.includes(g.id));
        
        const allQueues = new Set();
        const allAgents = new Set();
        
        selectedGroups.forEach(group => {
          if (group.queues) {
            group.queues.forEach(q => {
              const qId = q && typeof q === 'object' ? q.id || q._id : q;
              // Tenta mapear através da queuesList se necessário
              if (queuesList.length > 0) {
                 const found = queuesList.find(ql => String(ql[queueCompareField]) === String(qId) || String(ql._id) === String(qId) || String(ql.id) === String(qId));
                 if (found) {
                   allQueues.add(found[queueValueField]);
                   return;
                 }
              }
              allQueues.add(qId);
            });
          }

          if (group.accessAgentsLogin) {
            group.accessAgentsLogin.forEach(agentItem => {
               const login = agentItem && typeof agentItem === 'object' ? agentItem.login : agentItem;
               // Compara contra agentCompareField ou fallback para 'login'
               const foundAgent = agentsList.find(a => String(a[agentCompareField]) === String(login) || String(a.login) === String(login));
               if (foundAgent && foundAgent[agentValueField]) {
                 allAgents.add(foundAgent[agentValueField]);
               } else if (agentValueField === 'login' || agentValueField === agentCompareField) {
                 allAgents.add(login);
               }
            });
          }
        });
        
        setValue(queueField, Array.from(allQueues), { shouldValidate: true, shouldDirty: true });
        setValue(agentField, Array.from(allAgents), { shouldValidate: true, shouldDirty: true });
      } else if (prevSelectedRef.current !== null && (!selectedGroupingsIds || selectedGroupingsIds.length === 0)) {
        // Só limpa se foi previamente definido (usuário removeu o último agrupamento)
        setValue(queueField, [], { shouldValidate: true, shouldDirty: true });
        setValue(agentField, [], { shouldValidate: true, shouldDirty: true });
      }
      prevSelectedRef.current = selectedGroupingsIds;
    }
  }, [selectedGroupingsIds, groupings, setValue, queueField, agentField, agentsList, agentValueField]);

  return (
    <Col md={colSize}>
      <label className="form-control-label">
        Agrupamento
      </label>
      <Controller
        render={(props) => (
          <FlexSelect
            dataOptions={groupings}
            isMulti={true}
            value={props.value}
            valueController={setValue}
            closeMenuOnSelect={false}
            isClearable={true}
            fieldName="agrupamentos_macro_id"
            labelName="name"
            valueName="id"
            isLoading={isLoading}
            placeholder="Selecione..."
          />
        )}
        control={control}
        name="agrupamentos_macro_id"
        defaultValue={[]}
      />
    </Col>
  );
};

export default GroupingsMacroFilter;
